import { useState } from 'react';

import { useQueryClient } from 'react-query';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useMutationDeleteAlias } from 'api/mutations/deleteAlias.mutation';

import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { CustomizedConfirmDeleteModal, CustomizedRoundIcon } from 'components/common';
import classes from 'components/widgets/AliasPreferences/components/Cells/RowOptionsCell.module.scss';
import { EditAliasModal } from 'components/widgets/AliasPreferences/components/Cells/components/EditAliasModal/EditAliasModal';

export const RowOptionsCell = ({ row, data }) => {
    const [showEditAliasModal, setShowEditAliasModal] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const { handleSnackBar } = useCustomSnackBar();
    const mutation = useMutationDeleteAlias();
    const queryClient = useQueryClient();

    const handleEditAlias = () => {
        setShowEditAliasModal(true);
    };

    const handleDelete = () => {
        mutation.mutate(row.original?.id, {
            onSuccess: () => {
                handleSnackBar('Successfully deleted!', 'success');
            },
            onError: (error) => {
                DEFAULT_ERROR({ error, handleError: handleSnackBar });
            },
            onSettled: () => {
                setShow(false);
                queryClient.invalidateQueries('useQueryGetActivityCodesAliases');
            },
        });
    };

    const handleHideEditAliasModal = () => {
        setShowEditAliasModal(false);
    };

    return (
        <div className={classes.rowOptionsCellContainer}>
            <CustomizedRoundIcon onClick={handleEditAlias}>
                <Icon name={'edit-user-profile'} />
            </CustomizedRoundIcon>

            <CustomizedRoundIcon onClick={() => setShow(true)}>
                <MuiIcon icon={'delete'} type={'outlined'} />
            </CustomizedRoundIcon>
            <CustomizedConfirmDeleteModal
                isShowModal={show}
                hideModal={() => setShow(false)}
                text={`Are you sure you want to delete this alias mapping?`}
                onConfirm={handleDelete}
                isLoading={mutation?.isLoading}
            />

            <EditAliasModal
                showModal={showEditAliasModal}
                onHideModal={handleHideEditAliasModal}
                data={row.original}
                tableData={data}
            />
        </div>
    );
};
